import { ContentHeader } from '@croquiscom-pvt/zds';

interface CarouselTitleProps {
  title: string;
  isAd: boolean;
}

export const CarouselTitle = ({ title, isAd }: CarouselTitleProps) => (
  <ContentHeader title={title} right={isAd ? [{ type: 'ad' }] : []} />
);
